module.exports = __webpack_public_path__ + "img/layers-4.78ff5007.svg";